import React from "react";
import styled from "styled-components";
import { IPageSectionResponse } from "models/response/page-section-response";
import { SectionTitle } from "../custom-page.styles";

const FreeTextContainer = styled.div`
  margin-bottom: 30px;
`;

const FreeTextContent = styled.div`
  font-size: 16px;
  line-height: 1.8;
  color: #555;

  p {
    margin-bottom: 15px;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-top: 20px;
    margin-bottom: 15px;
    color: #333;
  }

  ul, ol {
    margin-left: 20px;
    margin-bottom: 15px;
  }

  a {
    color: #1976d2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  img {
    max-width: 100%;
    height: auto;
    margin: 15px 0;
  }

  blockquote {
    border-left: 4px solid #1976d2;
    padding-left: 20px;
    margin: 20px 0;
    font-style: italic;
    color: #666;
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

interface FreeTextSectionProps {
    section: IPageSectionResponse;
}

export const FreeTextSection: React.FC<FreeTextSectionProps> = ({ section }) => {
    return (
        <FreeTextContainer>
            {section.title && <SectionTitle>{section.title}</SectionTitle>}
            <FreeTextContent
                dangerouslySetInnerHTML={{
                    __html: section.content || ''
                }}
            />
        </FreeTextContainer>
    );
};
